export default {
    dependencies: ['$element', 'finnstream'],
    callable(ele, streamService) {
        ele.addEventListener(
            'click',
            () => {
                streamService.clearLastModified();
                try {
                    window.localStorage.setItem('must-revalidate-login', 'yup');
                } catch (e) {}
            },
            false
        );
    },
};



// WEBPACK FOOTER //
// ./controllers/loginLinkValidation.js